import { hireTeamImages } from "../assets/hireteam/hireteam";

export const HireTeamContentConfig = [
  // Hire Web Developers
  {
    pageName: "reactjs-developer",
    title: "Build Your Custom ReactJS Solution with Our Experts",
    content:
      "Our seasoned ReactJS developers in India are ready to help you create a robust and scalable product tailored to your unique needs. From initial concept to continuous support, we ensure your project is in the best hands.",
    backgroundImage: hireTeamImages.hero.reactJS,
    alt: "react-banner",
    developer: "ReactJS",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],

    technologyList: {
      title: "Our ReactJS Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.reactJS,
      alt: "react-js",
    },
  },
  {
    pageName: "angularjs-developer",
    content:
      "Our AngularJS developers are adept at creating dynamic web applications using the Angular framework. They offer comprehensive AngularJS development services to build feature-rich applications.",
    backgroundImage: hireTeamImages.hero.angularJS,
    alt: "angular-banner",
    developer: "AngularJS",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our AngularJS Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.angularJS,
      alt: "angular-js",
    },
  },
  {
    pageName: "vuejs-developer",
    content:
      "Our team of VueJS developer mastering in HTML/CSS, Typescript and Modern JavaScript (ES6 – ES7 – ES8), Leverage our Front end Developer and lead the rase of impressive user experience powered by HTML/CSS and React, We provide dedicated VueJS developers for hire at quick turnaround time.",
    backgroundImage: hireTeamImages.hero.vuejs,
    alt: "vue-banner",
    developer: "VueJS",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our VueJS Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.vuejs,
      alt: "vue-js",
    },
  },
  {
    pageName: "nodejs-developer",
    title: "Build Your Custom NodeJS Solution with Our Experts",
    content:
      "Our team of NodeJS developer mastering innetwork security, NodeJS, ExpressJS, NestJS, GraphQL, PL/SQL and MongoDB that helps businesses build web applications that are secure, fast, performance driven, We provide dedicated NodeJS developers for hire at quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.nodejs,
    alt: "node-banner",
    developer: "NodeJS",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our NodeJS Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.nodejs,
      alt: "node-js",
    },
  },
  {
    pageName: "golang-developer",
    content:
      "Our team of GoLang developer mastering in PL/SQL, MongoDB and GoLang and helps businesses build web applications that are secure, fast, performance driven, We provide dedicated GoLang developers for hire at quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.golang,
    alt: "golang-banner",
    developer: "Golang",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Golang Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.golang,
      alt: "golang",
    },
  },
  {
    pageName: "mern-stack-developer",
    content:
      "If you are looking for cost effective MERN stack team to support your frontend and backend developement, Our team of full stack developer mastering in React.js, Node.js, Express.js, NestJS, PL/SQL and MongoDB. We provide dedicated MERN stack developers for hire at quick turnaround time.",
    backgroundImage: hireTeamImages.hero.mernStack,
    alt: "mern-stack-banner",
    developer: "MERN Stack",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our MERN Stack Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.mernStack,
      alt: "vue-js",
    },
  },
  {
    pageName: "mean-stack-developer",
    content:
      "If you are looking for cost effective MEAN stack team to support your frontend and backend developement, Our team of full stack developer mastering in React.js, Node.js, Express.js, NestJS, PL/SQL and MongoDB. We provide dedicated MEAN stack developers for hire at quick turnaround time.",
    backgroundImage: hireTeamImages.hero.meanStack,
    alt: "mean-stack-banner",
    developer: "MEAN Stack",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our MEAN Stack Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.meanStack,
      alt: "vue-js",
    },
  },

  {
    pageName: "full-stack-java-developer",
    content:
      "If you are looking for cost effective MEAN stack team to support your frontend and backend developement, Our team of full stack java developer mastering in React.js, Node.js, Express.js, NestJS, PL/SQL and MongoDB. We provide dedicated full stack java developers for hire at quick turnaround time.",
    backgroundImage: hireTeamImages.hero.fullstackJava,
    alt: "full-stack-banner",
    developer: "Full Stack Java",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Full Stack Java Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.fullstackJava,
      alt: "vue-js",
    },
  },
  {
    pageName: "full-stack-python-developer",
    content:
      "If you are looking for cost effective MEAN stack team to support your frontend and backend developement, Our team of full stack python developer mastering in React.js, Node.js, Express.js, NestJS, PL/SQL and MongoDB. We provide dedicated full stack java developers for hire at quick turnaround time.",
    backgroundImage: hireTeamImages.hero.fullstackPython,
    alt: "full-stack-banner",
    developer: "Full Stack Python",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Full Stack Python Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.fullstackPython,
      alt: "vue-js",
    },
  },
  {
    pageName: "php-developer",
    content:
      "If you are looking for cost effective Fullstack Python Developers team to support your frontend and backend developement, Our team of full stack developer mastering in Python, HTML5/CSS3, Django, Flask, PL/SQL and MongoDB. We provide dedicated Fullstack Python developers for hire at quick turnaround time.",
    backgroundImage: hireTeamImages.hero.php,
    alt: "php-banner",
    developer: "PHP",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our PHP Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.php,
      alt: "php",
    },
  },
  {
    pageName: "wordpress-developer",
    title: "Build Your Custom WordPress Solution with Our Experts",
    content:
      "Our team of Wordpress developer mastering in HTML/CSS, Wordpress Customization, Wordpress Security and PHP. We provide dedicated Wordpress developers for hire at quick turnaround time.",
    backgroundImage: hireTeamImages.hero.wordpress,
    alt: "wordpress-banner",
    developer: "WordPress",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our WordPress Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.wordpress,
      alt: "wordpress",
    },
  },
  {
    pageName: "moodle-developer",
    content:
      "Our team of Moodle developers mastering in Moodle, PHP, Laravel, Codeignitor and PL/SQL. We provide dedicated Moodle developers for hire at quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.moodle,
    alt: "moodle-banner",
    developer: "Moodle",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Moodle Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.moodle,
      alt: "Moodle developer",
    },
  },
  {
    pageName: "aspnet-developer",
    title: "Build Your Custom ASP.NET Solution with Our Experts",
    content:
      "Our team of ASP.NET developers mastering in MVC framework,C#, NoSQL and ASP.NET Core that helps businesses build web applications that are secure, fast, performance driven, We provide dedicated ASP.NET developers for hire at quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.aspNet,
    alt: "aspnet-banner",
    developer: "ASP.NET",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our .NET Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.aspNet,
      alt: "dotnet",
    },
  },

  // Hire Mobile Developers
  {
    pageName: "ios-developer",
    title: "Build Your Custom IOS Solution with Our Experts",
    content:
      "There are many reasons why you would want to hire a developer for an iOS App. From the main idea to prototyping, testing, and getting it approved in the App store - it can be quite a difficult task if you do not have the necessary expertise to do it.\n\nThe iOS ecosystem has high penetration in developed countries, and the user base has high spending power. Our iOS developers have the world-class expertise to get your app done from start to finish, seamlessly.",
    backgroundImage: hireTeamImages.hero.ios,
    alt: "ios-banner",
    developer: "IOS",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our IOS Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.ios,
      alt: "IOS",
    },
  },
  {
    pageName: "android-developer",
    title: "Build Your Custom Android Solution with Our Experts",
    content:
      "If you are looking to hire a developer to build an App to serve around 1 billion people, then Android is your answer. Whether it’s a simple or complex app, our team is equipped to help you at every step of the way.",
    backgroundImage: hireTeamImages.hero.android,
    alt: "android-banner",
    developer: "Android",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Android Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.android,
      alt: "Android",
    },
  },
  {
    pageName: "reactnative-developer",
    title: "Build Your React Native Solution with Our Experts",
    content:
      "Our team of React Native developers mastering in complex Mobile app development, Flux, Flow, Redux and HTML/CSS. Our devlopers lead the rase of impressive user experience powered by HTML/CSS and React Native, We provide dedicated React Native developers for hire at quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.reactNative,
    alt: "reactnative-banner",
    developer: "React Native",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our React Native Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.reactNative,
      alt: "React Native",
    },
  },
  {
    pageName: "flutter-developer",
    title: "Build Your Custom Flutter Solution with Our Experts",
    content:
      "Flutter is fastly growing open-source software development kit which enables smooth and easy cross-platform mobile app development. You can build high quality natively compiled apps for iOS and Android quickly, without having to write the code for the two apps separately.. Whether it’s a simple or complex app, our team is equipped to help you at every step of the way.",
    backgroundImage: hireTeamImages.hero.flutter,
    alt: "flutter-banner",
    developer: "Flutter",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Flutter Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.flutter,
      alt: "Flutter",
    },
  },
  {
    pageName: "ionic-developer",
    title: "Build Your Custom Ionic Solution with Our Experts",
    content:
      "Our team of Ionic engineers experts in Cordova, Ionic and Phonegap, whether it’s a simple or complex app, our team is equipped to help you at every step of the way. We provide dedicated React Native developers for hire at quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.ionic,
    alt: "ionic-banner",
    developer: "Ionic",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Ionic Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.ionic,
      alt: "Ionic",
    },
  },
  {
    pageName: "xamarin-developer",
    title: "Hire a Xamarin Developer",
    content:
      "Our team of Xamarin engineers experts in Native Script, Cordova, Ionic and Phonegap that helps creation of software applications that are compatible with multiple mobile operating systems, whether it’s a simple or complex app, our team is equipped to help you at every step of the way. We provide dedicated developers for hire at quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.xamarin,
    alt: "ionic-banner",
    developer: "Xamarin",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Xamarin Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.xamarin,
      alt: "xamarin",
    },
  },

  //Hire Quality Assurance Engineers
  {
    pageName: "hire-manual-QA-engineer",
    title: "Hire A Manual QA Engineer",
    content:
      "Our team of Manual QA engineers has deep knowledge in various domains like healthcare, banking, eCommerce, and taxation, ensuring that your software’s functionality matches the initial design documents and is free of bugs. We provide dedicated Manual QA Engineers for hire with quick turnaround times, whether on a full-time, part-time, or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.manualQA,
    alt: "manual-qa-banner",
    developer: "Manual QA",
    benefits: [
      "All engineers are bound by strict confidentiality and privacy NDAs.",
      "An engineer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing engineers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick engineers according to your requirements. We let you conduct interviews with our engineers before you onboard them on your project.",
      "All engineers well-versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Manual QA Engineers Are Highly Skilled",
      image: hireTeamImages.technologyImg.softwareTestEngineer, // Update the image reference here
      alt: "Manual QA",
    },
  },
  {
    pageName: "hire-automation-test-engineer",
    title: "Hire An Automation Test Engineer",
    content:
      "We provide Automation Test Engineers who create useful end-to-end automation test scripts and have deep knowledge in various domains like healthcare, banking, eCommerce, and taxation. Our engineers ensure that your software’s functionality matches the initial design documents and is free of bugs. We provide dedicated Automation Test Engineers for hire with quick turnaround times, whether on a full-time, part-time, or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.automationTestEngineer,
    alt: "automation-test-engineer-banner",
    developer: "Automation Test",
    benefits: [
      "All engineers are bound by strict confidentiality and privacy NDAs.",
      "An engineer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing engineers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick engineers according to your requirements. We let you conduct interviews with our engineers before you onboard them on your project.",
      "All engineers well-versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Automation Test Engineers Are Highly Skilled",
      image: hireTeamImages.technologyImg.softwareTestEngineer, // No change to image reference
      alt: "Automation Test",
    },
  },
  {
    pageName: "hire-security-test-engineer",
    title: "Hire A Security Test Engineer",
    content:
      "Our team of Security Test Engineers are experts in various security disciplines such as information security monitoring, incident response, vulnerability management, host and network forensics, cyber-crime investigation, penetration testing, and threat modeling. We provide dedicated Security Test Engineers for hire with quick turnaround times, whether on a full-time, part-time, or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.securityTestEngineer,
    alt: "security-test-engineer-banner",
    developer: "Security Test",
    benefits: [
      "All engineers are bound by strict confidentiality and privacy NDAs.",
      "An engineer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing engineers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick engineers according to your requirements. We let you conduct interviews with our engineers before you onboard them on your project.",
      "All engineers well-versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Security Test Engineers Are Highly Skilled",
      image: hireTeamImages.technologyImg.securityTestEngineer, // No change to image reference
      alt: "Security Test",
    },
  },

  //Hire Specialized Experts
  {
    pageName: "awscloud-developer",
    title: "Hire A AWS Cloud Developer",
    content:
      "Our team of AWS Cloud Developers are experts in designing and deploying enterprise-wide scalable operations on the AWS cloud platform. We provide dedicated AWS Cloud Developers for hire at quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.awsCloud,
    alt: "aws-cloud-banner",
    developer: "AWS Cloud",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our AWS Cloud Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.awsCloud,
      alt: "AWS Cloud",
    },
  },
  {
    pageName: "azurecloud-developer",
    title: "Hire A Azure Cloud Developer",
    content:
      "Our team of Azure Cloud Developers are experts in designing and deploying enterprise-wide scalable operations on the Azure cloud platform. We provide dedicated Azure Cloud Developers for hire at quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.azureCloud,
    alt: "azure-cloud-banner",
    developer: "Azure Cloud",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Azure Cloud Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.azureCloud,
      alt: "Azure Cloud",
    },
  },
  {
    pageName: "gcpcloud-developer",
    title: "Hire A GCP Cloud Developer",
    content:
      "Our team of GCP Cloud Developers are experts in designing and deploying enterprise-wide scalable operations on the GCP cloud platform. We provide dedicated GCP Cloud Developers for hire with quick turnaround times, whether on a full-time, part-time, or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.gcpCloud,
    alt: "gcp-cloud-banner",
    developer: "GCP Cloud",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well-versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our GCP Cloud Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.gcpCloud, // Update this with a relevant GCP image if available
      alt: "GCP Cloud",
    },
  },
  {
    pageName: "devops-developer",
    title: "Hire A DevOps Professional",
    content:
      "Shorten your systems development life cycle and deliver high quality software. Get end-to-end automation for shorter time-to-market, resulting in faster product release using our robust infrastructure. Our team ensures agile delivery by reducing iterations, anticipating problems, and ensuring smooth execution throughout the process. We provide dedicated DevOps Engineers for hire at a quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.devops,
    alt: "DevOps-banner",
    developer: "DevOps",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our DevOps Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.devops,
      alt: "DevOps",
    },
  },
  {
    pageName: "ml-developer",
    title: "Hire Machine Learning Engineer",
    content:
      "Our team of Machine Learning engineers are experienced with AI/Machine Learning/data science technology to meet your business needs. We offer smart AI / ML solutions that are cost effective in nature and offer detailed insights that can help the business grow. We provide dedicated Machine Learning Engineers for hire at a quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.machineLearning,
    alt: "ml-banner",
    developer: "Machine Learning",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our ML Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.machineLearning,
      alt: "ml",
    },
  },
  {
    pageName: "blockchain-developer",
    title: "Hire A Blockchain Developer",
    content:
      "Future-proof your business with the power of blockchain technology. Our specialists can create and implement secure digital solutions, ensuring that information distributed publicly via the Internet remains protected from copying or tampering. We provide dedicated Blockchain developers for hire with quick turnaround times, whether on a full-time, part-time, or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.blockchain,
    alt: "blockchain-banner",
    developer: "Blockchain",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well-versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Blockchain Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.blockchain, // Update this with a relevant Blockchain image if available
      alt: "Blockchain",
    },
  },
  {
    pageName: "rpa-developer",
    title: "Hire A RPA Developer",
    content:
      "Increase productivity in your business and daily operations using - Robotic Process Automation. Automate manual processes for any repetitive, rule-based and high volume jobs that you have. Hire an RPA developer to help you create human-like manual interaction, reduce human error and turn around times, and even annual savings. We provide dedicated RPA developers for hire at quick turnaround time either fulltime, parttime or ad-hoc basis.",
    backgroundImage: hireTeamImages.hero.rpa,
    alt: "rpa-banner",
    developer: "RPA",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our RPA Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.rpa,
      alt: "RPA",
    },
  },

  {
    pageName: "uiux-developer",
    title: "Hire A UI/UX Developer",
    content:
      "Our team of UI & UX engineers are experts in applying interactive and visual design principles on websites, mobile and web applications for a positive and cohesive user experience. We provide dedicated UI/UX developers for hire at quick turnaround time.",
    backgroundImage: hireTeamImages.hero.uiux,
    alt: "UI/UX-banner",
    developer: "UI/UX",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our UI/UX Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.uiux,
      alt: "UI/UX",
    },
  },
  {
    pageName: "powerbi-developer",
    title: "Hire A Power BI Developer",
    content:
      "With the help of our experts in Power BI, turn your unrelated sources of data into coherent, visually immersive, and interactive insights. We provide dedicated Power BI developers for hire at a quick turnaround time.",
    backgroundImage: hireTeamImages.hero.powerbi,
    alt: "powerbi-banner",
    developer: "Power BI",
    benefits: [
      "All developers are bound by strict confidentiality and privacy NDAs.",
      "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      "Alleviate the pressure of a backlog without hiring, training, and maintaining long-term salaries.",
      "Transparent management and communication. You’re managing developers directly. You always know what your team is doing and where they are on the progress scale at the moment.",
      "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
      "We handpick developers according to your requirement. We let you conduct interviews with our developers before you onboard them on your project.",
      "All developers well versed with Agile/SCRUM Development Methodology.",
      "Low employee turnover rate.",
      "Two-week risk-free trial.",
      "Dedicated Customer Success Manager.",
    ],
    technologyList: {
      title: "Our Power BI Developers Are Highly Skilled",
      image: hireTeamImages.technologyImg.powerbi,
      alt: "Power BI",
    },
  },
];

export const hireTeamUrlRouting = [
  {
    pathname: "/services/hire_reactjs_developer",
    pageName: "reactjs-developer",
  },
  {
    pathname: "/services/hire_angular_developer",
    pageName: "angularjs-developer",
  },
  {
    pathname: "/services/hire_VueJS_developer",
    pageName: "vuejs-developer",
  },
  {
    pathname: "/services/hire_UIUX_developer",
    pageName: "uiux-developer",
  },
  {
    pathname: "/services/hire_GoLang_developer",
    pageName: "golang-developer",
  },
  {
    pathname: "/services/hire_aspnet_developer",
    pageName: "aspnet-developer",
  },
  {
    pathname: "/services/hire_php_developer",
    pageName: "php-developer",
  },
  {
    pathname: "/services/hire_flutter_developer",
    pageName: "flutter-developer",
  },
  {
    pathname: "/services/hire_ionic_developer",
    pageName: "ionic-developer",
  },
  {
    pathname: "/services/hire_ios_developer",
    pageName: "ios-developer",
  },
  {
    pathname: "/services/hire_android_developer",
    pageName: "android-developer",
  },
  {
    pathname: "/services/hire_rpa_developer",
    pageName: "rpa-developer",
  },
  {
    pathname: "/services/hire_ml_engineer",
    pageName: "ml-developer",
  },
  {
    pathname: "/services/hire_devops_engineer",
    pageName: "devops-developer",
  },
  {
    pathname: "/services/hire_Power_BI_Developer",
    pageName: "powerbi-developer",
  },
  {
    pathname: "/services/hire_AWS_Cloud_developer",
    pageName: "awscloud-developer",
  },
  {
    pathname: "/services/hire_AZURE_Cloud_developer",
    pageName: "azurecloud-developer",
  },
  {
    pathname: "/services/hire_reactnative_developer",
    pageName: "reactnative-developer",
  },
  {
    pathname: "/services/hire_Nodejs_developer",
    pageName: "nodejs-developer",
  },
  {
    pathname: "/services/hire_moodle_developer",
    pageName: "moodle-developer",
  },
  {
    pathname: "/services/hire_MERN_stack_developer",
    pageName: "mern-stack-developer",
  },
  {
    pathname: "/services/hire_MEAN_stack_developer",
    pageName: "mean-stack-developer",
  },
  {
    pathname: "/services/hire_fullstack_java_developer",
    pageName: "full-stack-java-developer",
  },
  {
    pathname: "/services/hire_Python_Fullstack_developer",
    pageName: "full-stack-python-developer",
  },
  {
    pathname: "/services/hire_WordPress_developer",
    pageName: "wordpress-developer",
  },
  {
    pathname: "/services/hire_xamarin_developer",
    pageName: "xamarin-developer",
  },
  {
    pathname: "/services/hire_manual_QA_engineer",
    pageName: "hire-manual-QA-engineer",
  },
  {
    pathname: "/services/hire_automation_test_engineer",
    pageName: "hire-automation-test-engineer",
  },
  {
    pathname: "/services/hire_security_test_engineer",
    pageName: "hire-security-test-engineer",
  },
  {
    pathname: "/services/hire_GCP_Cloud_developer",
    pageName: "gcpcloud-developer",
  },
  {
    pathname: "/services/hire_blockchain_developer",
    pageName: "blockchain-developer",
  },
];
